import React from 'react';
import PropTypes from 'prop-types';

const Calendar = ({
	onCloseClick,
	googleCalendarUrl,
	googleCalendarIcon,
	googleCalendarLabel,
	outlookCalendarUrl,
	outlookCalendarIcon,
	outlookCalendarLabel,
	appleCalendarUrl,
	appleCalendarIcon,
	appleCalendarLabel,
	title,
	copy,
	buttonLabel,
}) => {
	const mainTitle = title || title.length ? <h1 className="modal__calendar__title">{title}</h1> : null;
	const copyText = copy || copy.length ? <p className="modal__calendar__title-sub">{copy}</p> : null;
	return (
		<section className="modal__calendar">
			<button type="button" className="modal__close modal__calendar__close" onClick={onCloseClick} />
			{mainTitle}
			{copyText}
			<div className="modal__calendar__calendars">
				{(googleCalendarUrl && googleCalendarIcon)
					? (
						<a href={googleCalendarUrl} target="_blank" rel="noopener noreferrer" className="calendar-item">
							<img className="calendar-icon" src={googleCalendarIcon} alt="google calendar icon" />
							<p className="calendar-label">{googleCalendarLabel}</p>
						</a>
					)
					: null}
				{(appleCalendarUrl && appleCalendarIcon)
					? (
						<a href={appleCalendarUrl} className="calendar-item">
							<img className="calendar-icon" src={appleCalendarIcon} alt="ical calendar icon" />
							<p className="calendar-label">{appleCalendarLabel}</p>
						</a>
					)
					: null}
				{(outlookCalendarUrl && outlookCalendarIcon)
					? (
						<a href={outlookCalendarUrl} className="calendar-item">
							<img className="calendar-icon" src={outlookCalendarIcon} alt="outlook calendar icon" />
							<p className="calendar-label">{outlookCalendarLabel}</p>
						</a>
					)
					: null}
			</div>
			<div className="btn-container">
				<button type="button" className="btn btn--primary" onClick={onCloseClick}>{buttonLabel}</button>
			</div>
		</section>
	);
};

Calendar.defaultProps = {
	googleCalendarUrl: '',
	googleCalendarIcon: '',
	googleCalendarLabel: 'Google Calendar',
	outlookCalendarUrl: '',
	outlookCalendarIcon: '',
	outlookCalendarLabel: 'Outlook Calendar',
	appleCalendarUrl: '',
	appleCalendarIcon: '',
	appleCalendarLabel: 'iCal',
	onCloseClick: () => { },
	title: '',
	copy: '',
	buttonLabel: 'Close',
};

Calendar.propTypes = {
	googleCalendarUrl: PropTypes.string,
	googleCalendarLabel: PropTypes.string,
	googleCalendarIcon: PropTypes.string,
	outlookCalendarUrl: PropTypes.string,
	outlookCalendarIcon: PropTypes.string,
	outlookCalendarLabel: PropTypes.string,
	appleCalendarUrl: PropTypes.string,
	appleCalendarIcon: PropTypes.string,
	appleCalendarLabel: PropTypes.string,
	onCloseClick: PropTypes.func,
	title: PropTypes.string,
	copy: PropTypes.string,
	buttonLabel: PropTypes.string,
};

export default Calendar;
